module.exports = __webpack_public_path__ + "img/E0A7.95432e47.svg";